<template>
	<div class="legend" v-if="ChartApi.$data._chart && metadata">
		<div class="columns is-mobile is-multiline is-centered">
			<div class="column is-one-quarter-desktop is-half-touch is-narrow" v-for="(d, i) in metadata" @click="updateChartData(i)">
				<div class="is-pointer label-text" v-if="metadata[i].hidden == true && chart.labels[i]">
					<div style="display: inline-block;height: 13px; width: 40px;" :style="'background-color:' + dataset.backgroundColor[i]"></div>
					<s>&nbsp;{{chart.labels[i]}}</s>
				</div>
				<div class="is-pointer label-text" v-if="!metadata[i].hidden && chart.labels[i]">
					<div style="display: inline-block;height: 13px; width: 40px;" :style="'background-color:' + dataset.backgroundColor[i]"></div>
					&nbsp;{{chart.labels[i]}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			Chart: Object,
			ChartApi: Object,
			Options: Object
		},
		data() {
			return {
				chart: [],
				dataset: {},
				metadata: []
			}
		},
		created() {
			this.chart = this.Chart;
			this.dataset = this.chart.datasets[0];
			this.metadata = this.ChartApi.$data._chart.getDatasetMeta(0).data;
		},
		watch: {
			ChartApi: function (val) {
				//console.log(val)
				this.metadata = [];
				this.metadata = val.$data._chart.getDatasetMeta(0).data;
			},
			Chart: function (val) {
				this.chart = val;
			},
			chart: function (val) {
				this.dataset = val.datasets[0];
			},
		},
		methods: {
			updateChartData(i) {
				this.$set(this.ChartApi.$data._chart.getDatasetMeta(0).data[i], 'hidden', !this.ChartApi.$data._chart.getDatasetMeta(0).data[i].hidden);
				this.ChartApi.$data._chart.update();
			}
		}
	}
</script>

<style>
	.legend {
	}

	.item {
		cursor: pointer;
	}


	.label-text {
		font-size: 16px;
		margin-left: 10px;
		color: rgb(117, 117, 117);
		text-decoration-style: solid 3px;
	}
</style>
